import { useEffect, useState } from "react";
import {
  getUnsyncedServices,
  isOnline,
  pendingServiceSummary,
  subscribeOfflineServices,
} from "../../utils/offlineStorage";

export function useOnlineStatus() {
  const [online, setOnline] = useState(isOnline());
  useEffect(() => {
    const refresh = () => setOnline(isOnline());
    window.addEventListener("online", refresh);
    window.addEventListener("offline", refresh);
    return () => {
      window.removeEventListener("online", refresh);
      window.removeEventListener("offline", refresh);
    };
  }, []);
  return online;
}

export default function PendingServiceNotice() {
  const online = useOnlineStatus();
  const [pending, setPending] = useState(() => getUnsyncedServices());

  useEffect(() => {
    const refresh = () => setPending(getUnsyncedServices());
    refresh();
    return subscribeOfflineServices(refresh);
  }, []);

  if (pending.length === 0 && online) return null;

  const tone = online ? "#155724" : "#721c24";
  const background = online ? "#d4edda" : "#f8d7da";
  const border = online ? "#c3e6cb" : "#f5c6cb";

  return (
    <div
      style={ {
        padding: "12px 16px",
        marginBottom: "16px",
        background,
        border: `1px solid ${border}`,
        borderRadius: "4px",
        fontSize: "14px",
        color: tone,
      } }
    >
      <div style={ { display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" } }>
        <strong>{ online ? "Online" : "Offline" }</strong>
        { pending.length > 0 && online && (
          <button
            type="button"
            onClick={ () => window.dispatchEvent(new Event("ecrane-offline-services-sync")) }
            style={ {
              padding: "8px 16px",
              background: "#28a745",
              color: "#ffffff",
              border: "none",
              borderRadius: "4px",
              fontSize: "14px",
              cursor: "pointer",
            } }
          >
            Send saved services
          </button>
        ) }
      </div>
      { pending.length > 0 && (
        <>
          <div style={ { marginTop: "8px" } }>
            { pending.length === 1
              ? "1 service is saved on this device and has not been sent."
              : `${pending.length} services are saved on this device and have not been sent.` }
          </div>
          <ul style={ { margin: "8px 0 0", paddingLeft: "18px" } }>
            { pending.map((item) => (
              <li key={ item.key }>{ pendingServiceSummary(item) }</li>
            )) }
          </ul>
          <div style={ { marginTop: "8px" } }>
            Clearing this site&apos;s data in the browser removes these services before they send.
          </div>
        </>
      ) }
      { pending.length === 0 && (
        <div style={ { marginTop: "8px" } }>
          You are offline. A service you save stays on this device until the connection returns.
        </div>
      ) }
    </div>
  );
}
